import validate from "/vercel/path0/psychiatry/node_modules/.pnpm/nuxt@3.19.0_@parcel+watcher@2.5.1_@vue+compiler-sfc@3.5.21_db0@0.3.2_eslint@8.57.1_ioredis@5._ow4hjenlguai5buvehfvazui2e/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/psychiatry/node_modules/.pnpm/nuxt@3.19.0_@parcel+watcher@2.5.1_@vue+compiler-sfc@3.5.21_db0@0.3.2_eslint@8.57.1_ioredis@5._ow4hjenlguai5buvehfvazui2e/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}